import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { CrossIcon } from "../../../svg/cross-icon";
import SideModal from "../filterModal/filterModal";
import CaseDetailsContent from "./panes/caseDetailsContent";
import HistoryPane from "./panes/historyPane";

interface NonEpaHistoryPanelProps {
  isOpen: boolean;
  data: PharmaStpFileModel;
  onClose: () => void;
}

/** Section heading above the case details and history blocks. */
const SECTION_HEADING_CLASSES = "m-0 text-h11 font-bold text-primaryGray-1";

/**
 * Read-only side panel opened from the history icon in the calling worklist
 * table. Shows the order's case details followed by every saved call and fax
 * summary, in one vertically scrolling column.
 *
 * @param props.isOpen - Drives the slide-in transition
 * @param props.data - Order row the panel was opened for
 * @param props.onClose - Clears the opened modal in redux
 */
const NonEpaHistoryPanel = (props: NonEpaHistoryPanelProps) => (
  <SideModal
    isOpen={props.isOpen}
    onClose={props.onClose}
    id="non-epa-history-panel"
    width="28%"
  >
    <div className="flex h-full flex-col bg-white">
      <div className="flex shrink-0 items-center justify-between border-b border-primaryGray-15 px-6 py-4">
        <h2 className="m-0 text-large font-bold text-primaryGray-1">History</h2>
        <button
          type="button"
          className="flex cursor-pointer items-center justify-center border-none bg-transparent p-1 hover:opacity-70"
          onClick={props.onClose}
          aria-label="Close history"
        >
          <CrossIcon fillColor="#374151" />
        </button>
      </div>

      <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-6 py-5">
        <h3 className={SECTION_HEADING_CLASSES}>Case Details</h3>
        <div className="rounded-lg border border-primaryGray-15">
          <CaseDetailsContent data={props.data} showGroupDivider={false} />
        </div>

        <h3 className={`${SECTION_HEADING_CLASSES} mt-3`}>History</h3>
        <HistoryPane data={props.data} disablePadding />
      </div>

      <div className="shrink-0 border-t border-primaryGray-15 px-6 py-4">
        <button
          type="button"
          className="flex w-full cursor-pointer items-center justify-center rounded border border-solid border-primaryGray-1 bg-white py-3 text-small font-bold text-primaryGray-1 hover:bg-primaryGray-15"
          onClick={props.onClose}
        >
          Close
        </button>
      </div>
    </div>
  </SideModal>
);

export default NonEpaHistoryPanel;
